import { usePrevious } from 'ahooks';

/**
 * @description https://ahooks.js.org/hooks/use-previous
 */
export default usePrevious;
